import { create } from 'zustand';

/**
 * Sipario di uscita dal login: un overlay che replica la pagina (ink | carta)
 * e scorre via ai lati mentre l'app si monta dietro. Vive fuori dalle route
 * (LoginCurtainRoot in App) così sopravvive al cambio di pagina.
 */
interface CurtainState {
  active: boolean;
  open: () => void;
  done: () => void;
}

export const useCurtainStore = create<CurtainState>((set) => ({
  active: false,
  open: () => set({ active: true }),
  done: () => set({ active: false }),
}));
